import { render, staticRenderFns } from "./GridHome.vue?vue&type=template&id=2b47ab01&scoped=true&"
import script from "./GridHome.vue?vue&type=script&lang=ts&"
export * from "./GridHome.vue?vue&type=script&lang=ts&"
import style0 from "./GridHome.vue?vue&type=style&index=0&id=2b47ab01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47ab01",
  null
  
)

export default component.exports